import React from 'react'
import { renderSlot, SlotId, ContentUnitId } from 'services/adition'

interface Props {
  show: boolean
  slotId: SlotId
  contentUnitId: ContentUnitId
}

class AdSlot extends React.Component<Props, {}> {
  componentDidMount() {
    const { show, slotId, contentUnitId } = this.props

    if (!show) {
      return
    }

    renderSlot(slotId, contentUnitId)
  }

  render() {
    const { show, slotId } = this.props

    if (!show) {
      return null
    }

    return <div id={slotId} />
  }
}

export default AdSlot
